import * as svg from "../../../assets/info-outline-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const InfoOutlineIcon = iconBuilder(svg, "InfoOutlineIcon", "0 0 38 38");
